import React from 'react';
import { Box, Container, CssBaseline, Stack, Typography} from "@mui/material";
import PageMidThree from './PageMidThree';
import page_mid_three_array from '../Arrays/page-mid-three-array';

function createPageThreeElements(elements) {
    return <PageMidThree alt={elements.alt}
    img={elements.imgURL}
    text={elements.text}
    text2={elements.text2}
    />;
}

function PageMidTwo () {
    return (
    <>
    <CssBaseline />
                                                                            {/* Alterações na parte de responsividade */}
    <Stack xs={12} md={6} sm={6} lg={6} xl={6} sx={{mt:'1px', mb:'100px', }} direction={{xs:'column', md:'row'}}  justifyContent="center" alignItems="center" spacing={4}>
        {page_mid_three_array.map(createPageThreeElements)}
        </Stack>

    <Container style={{padding:'0px'}} sx={{position:'relative', display:'block', minWidth:'100%'}}>
        <Box sx={{position:'relative'}}>
        <Stack sx={{width:'100%', height:'450px'}} component='img' src='images/objetivo.jpg' alt='Mid-img' />
        
        <Box sx={{position:'absolute' ,top:'40%', right:'10%', left:'10%', borderStyle:'solid', backgroundColor:'white', textAlign: 'center'}}>
            <Typography fontFamily='Crimson Text' variant='h4' fontWeight='500' sx={{color:'black', position: 'relative', zIndex: 1}}>
            Nosso objetivo
            </Typography>

            <Typography variant='h6' fontWeight='500' sx={{color:'black', opacity:'0.7', position: 'relative', zIndex: 1}}>
            Na Academia Billy Gym você contará com uma equipe com 22 anos de experiência, iremos trabalhar juntos para que você tenha muita alegria ao ver e sentir os resultados de seu treino em seu corpo e sua vida!
            </Typography>
        </Box>
        </Box>
    </Container>
     </>    
    );
};
export default PageMidTwo;
